module.exports = __webpack_public_path__ + "img/om.387f2104.webp";